var map = {
	"./DrLubhani/ChangeColor": [
		803,
		189
	],
	"./Ganga/ChangeColor": [
		805,
		196
	],
	"./Indus/ChangeColor": [
		807,
		210
	],
	"./Kabini/ChangeColor": [
		809,
		218
	],
	"./Kaveri/ChangeColor": [
		717,
		22
	],
	"./Luni/ChangeColor": [
		811,
		225
	],
	"./Narmada/ChangeColor": [
		813,
		229
	],
	"./Nethravathi/ChangeColor": [
		815,
		237
	],
	"./Neyyar/ChangeColor": [
		817,
		242
	],
	"./Periyar/ChangeColor": [
		819,
		246
	],
	"./SAANVI/ChangeColor": [
		821,
		257
	],
	"./Sabarmathi/ChangeColor": [
		823,
		265
	],
	"./Sparsh/ChangeColor": [
		825,
		272
	],
	"./Sutlej/ChangeColor": [
		827,
		277
	],
	"./Yamuna/ChangeColor": [
		829,
		284
	],
	"./pamba/ChangeColor": [
		831,
		294
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2083;
module.exports = webpackAsyncContext;